/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `
   {{#products}} 
   <li class="plists__item plists--cat1__item plists-item">
   <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
       <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
     </path></svg>
   </button>
   <a href="{{du}}"aria-label="{{dt}}" class="plists-item__link-wrapper">
     <div class="plists-item__img">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <h4 class="plists-item__name">{{taginfo}}<br>{{dt}}</h4>
   </a>
   
     <!--<button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>-->

     <!--<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>

     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
     </div>-->
     
      <!-- quick-add -->
      <div class="plists-item__link-box quick-add no-js-hidden">
        <product-form>
        <form method="post" action="/cart/add" id="quick-add-{{epi}}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="{{epi}}">
            <button
              id="quick-add-{{epi}}-submit"
              type="submit"
              name="add"
              class="plists-item__link quick-add__submit button button--full-width button--secondary"
              aria-haspopup="dialog"
              aria-labelledby="quick-add-{{epi}}-submit title--{{epi}}"
              aria-live="polite"
              data-sold-out-message="true"
            >
              <span>
                add to cart
              </span>
              <div class="loading-overlay__spinner hidden"></div>
            </button>
        </form>
        </product-form>
      </div>
      <!-- quick-add -->

     <!--<div class="plists-item__link-box">
       <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="custom-submit-button plists-item__link">
         {{#isInCart}}Add to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
       </button>
     </div>-->
   </li>
   {{/products}}`;

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "";
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function(c) {
    e.target.innerHTML = "Added to Cart";
    e.target.setAttribute("data-state-cart", "swym-added");
    console.log("Successfully added product to cart.", c);
  }, function(e) {
    console.log(e);
  });
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi){
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}

//情報追加ここから
function getData() {
  return $.ajax({
  url: '/products.json',
  type: 'GET',
  dataType: "json",
  });
}
//情報追加ここまで

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    console.log(products)
    console.log(products.length);

    if(!products.length || !products == null || !products == undefined ) {
      $('.wish-list__none').show(); 
    }

    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    var formattedWishlistedProducts = products.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");

      function getData() {
          var result = $.ajax({
              type: 'GET',
              url: '/products.json',
              async: false
          }).responseJSON;
          return result;
      }
      
      //情報追加ここから
      data = getData();

      var data_stringify = JSON.stringify(data);
      var data_json = JSON.parse(data_stringify);

      $.each(data_json,function(index, val) {
        $.each(val,function(productIndex, products) {
      	  if ( products.id == p.empi) {
      	    p.taginfo = products.tags;
      	  }
        });
      });

      //情報追加ここまで

      return p;

    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts
    });
    if(wishlistContentsContainer){
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else{
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */